import React from 'react';

import { useTheme } from '@mui/material/styles';

function UpArrowIcon({ isActive }) {
    const theme = useTheme();

    const color = isActive ? theme.palette.primary.main : theme.palette.icons.color;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" className="valign-middle">
            <path stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M8 10L12 6M12 6L16 10M12 6L12 18" />
        </svg>
    );
}

export default UpArrowIcon;
